import axios from "axios";

// Points to the PHP backend on the same Hostinger domain.
// All API calls go to /api/inquiries.php, /api/admin_verify.php etc.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});